import { App } from 'antd';
import { useCallback } from 'react';

import { MessageType, NotificationType } from '@/enums';

export const useAppFeedback = () => {
  const { message, notification, modal } = App.useApp();

  const showMessage = useCallback(
    (content: string, type: MessageType = MessageType.Info, duration = 3) => {
      return message[type](content, duration);
    },
    [message],
  );

  const showNotification = useCallback(
    (
      title: string,
      description?: string,
      type: NotificationType = NotificationType.Info,
      duration = 4.5,
    ) => {
      notification[type]({
        message: title,
        description,
        duration,
      });
    },
    [notification],
  );

  const showConfirm = useCallback(
    (
      title: string,
      content?: string,
      onOk?: () => void | Promise<void>,
      onCancel?: () => void,
      okText = '確定',
      cancelText = '取消',
      okType: 'primary' | 'danger' | 'dashed' | 'default' = 'primary',
    ) => {
      return modal.confirm({
        title,
        content,
        onOk,
        onCancel,
        okText,
        cancelText,
        okType,
      });
    },
    [modal],
  );

  return {
    showMessage,
    showNotification,
    showConfirm,
    message,
    notification,
    modal,
  };
};
